export interface Pump {
    id: number;
    created_by: number;
    last_modified_by: number;
    min_hertz: number;
    max_hertz: number;
    min_injection_rate: number;
    max_injection_rate: number;
    pump_make: PumpMake;
    pump_model: PumpModel;
    controller_brand: ControllerBrand;
    pump_serial_number: string;
    monitor_system: null;
    system_type: SystemType;
    grower: number;
    controller_id: null;
}

export enum SystemType {
    mobile = 1,
    variableRate = 2,
    constantRate = 3,
}

export enum ControllerBrand {
    cropLink = "Crop Link",
    boss = "BOSS",
    uVrf = "uVRF",
}

export enum PumpMake {
    agriInject = "Agri-Inject",
    neptune = "Neptune",
    johnBlue = "John Blue",
    sureFire = "SureFire",
    iFeeder = "I-Feeder",
    injectOMeter = "Inject-o-meter",
}

export enum PumpModel {
    reflexConnect = "Reflex Connect",
    reflexEvolution = "Reflex Evolution",
    standarad = "Standard",
    insectigator = "Insectigator",
    ezeGrab = "EZE-Grab",
    ezMeter = "E-Z Meter",
    marksman = "Marksman",
}
